import { approveRenewVehicleRequest } from "../data/renewVehicleApi";

export async function approveRenewVehicleUseCase(token, vehicle) {
  const vehicleId = Number(vehicle?.id);
  const requestId = Number(vehicle?.pendingChange?.requestId);

  if (!token) throw new Error("Inicia sesión como administrador para aprobar");
  if (!Number.isInteger(vehicleId) || vehicleId <= 0 ||
      !Number.isInteger(requestId) || requestId <= 0) {
    throw new Error("La solicitud pendiente no es válida");
  }

  try {
    const response = await approveRenewVehicleRequest(token, vehicleId, requestId);
    if (response.data?.message !== "ok" ||
        response.data?.data?.requestId !== requestId ||
        response.data?.data?.status !== "APPROVED") {
      throw new Error("No se pudo confirmar la aprobación");
    }
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 409) {
      const conflict = new Error("La solicitud cambió o ya fue revisada. La lista se actualizará.");
      conflict.code = "CONFLICT";
      throw conflict;
    }
    if (error.response?.status === 401 || error.response?.status === 403) {
      throw new Error("Tu sesión no tiene permiso para aprobar esta solicitud");
    }
    if (error.response?.status === 404) {
      throw new Error("El vehículo ya no está disponible para aprobación");
    }
    throw new Error("No se pudo aprobar el vehículo. Inténtalo nuevamente.");
  }
}
